<template>
  <div>
    <a-card style="margin:10px 0px;">
      <div class="text-right">
        <a-button
          type="primary"
          icon="plus"
          class="add-btn"
          @click="visible = true"
        >
          新增风险标签
        </a-button>
      </div>
      <TableView
        :data="tableData"
        :columns="tableColumns"
        :pagination="pageData"
        :scroll="{ x: 800 }"
        @handlePagination="handleClickPage"
        :loading="loading"
      >
        <template v-slot:action="{ tableRow }">
          <div>
            <a-button type="link" size="small" @click="handleEdit(tableRow)">
              编辑
            </a-button>
            <a-divider type="vertical" />
            <a-popconfirm
              title="此操作将删除该风险标签, 是否继续?"
              @confirm="handleDeleteConfirm(tableRow)"
            >
              <a-icon slot="icon" type="question-circle-o" class="icon-color" />
              <a-button type="link" size="small">
                删除
              </a-button>
            </a-popconfirm>
          </div>
        </template>
      </TableView>
    </a-card>

    <a-modal
      v-model="visible"
      destroyOnClose
      @ok="handleSubmit"
      :title="modalTitle"
      :maskClosable="false"
      :afterClose="handleAfterClose"
    >
      <a-form :form="modalForm">
        <a-form-item label="风险标签">
          <a-input :maxLength="100" allowClear v-decorator="['name']"></a-input>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import mixin from './mixin'
import { getTableData, add, remove } from './api'
import { TableView } from 'lxfintech-fe'
export default {
  data() {
    //这里存放数据
    return {
      modalForm: this.$form.createForm(this),
      loading: false,
      visible: false,
      modalTitle: '新增',
    }
  },
  mixins: [mixin],
  components: { TableView },

  //方法集合
  methods: {
    // 提交和编辑
    handleSubmit() {
      this.modalForm.validateFields(async (err, values) => {
        if (!err) {
          if (!this.id) {
            this.id = ''
          }
          try {
            const { message } = await add({
              ...values,
              id: this.id,
            })
            this.visible = false
            this.$notification.success({
              message: '提示',
              description: message,
            })
            this._getTableData()
          } catch (e) {
            // No processing
          }
        }
      })
    },
    // 点击编辑
    handleEdit({ name, id }) {
      this.visible = true
      this.modalTitle = '编辑'
      setTimeout(() => {
        this.modalForm.setFieldsValue({
          name,
        })
        this.id = id
      }, 20)
    },
    // 删除
    handleDeleteConfirm({ id }) {
      remove(id).then(({ message }) => {
        this.$notification.success({
          message: '提示',
          description: message,
        })
        this._getTableData()
      })
    },
    // 弹窗关闭
    handleAfterClose() {
      this.id = ''
      this.modalTitle = '新增'
    },
    async _getTableData() {
      try {
        this.loading = true
        const { current, pageSize } = this.pageData
        const query = {
          size: pageSize,
          current,
        }
        const {
          data: { total, records },
        } = await getTableData(query)
        this.pageData.total = total
        this.tableData = records
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this._getTableData()
  },
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
